module.exports = __webpack_public_path__ + "fonts/CrimsonText-Italic.69f39a51.ttf";